import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  menuCategory,
  menuItems as menuItemsData,
  operator1,
} from "components/Menu/Datamenu";
import MenuListWithSidebar from "components/Menu/MenuListWithSidebar";
import CartModal from "components/Cart/CartModal";
import CartBottomBar from "components/Menu/CartBottomBar";

const Menu = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    console.log("Menu mounted");
    return () => console.log("Menu unmounted");
  }, []);

  const [operator] = useState(operator1);
  const [menuCategories, setMenuCategories] = useState(menuCategory);
  const [menuItems, setMenuItems] = useState(menuItemsData);
  const [modalItem, setModalItem] = useState(null);

  const [selectedCategoryId, setSelectedCategoryId] = useState(
    menuCategories[0]?._id,
  );

  return (
    <div className="text-text text-4xl mt-20">
      <MenuListWithSidebar
        menuCategories={menuCategories}
        menuItems={menuItems}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={setSelectedCategoryId}
        setModalItem={setModalItem}
        expandedCategory={undefined} // <-- quick patch
      />{" "}
      {modalItem && (
        <CartModal item={modalItem} onClose={() => setModalItem(null)} />
      )}
      <CartBottomBar />
    </div>
  );
};

export default Menu;
